const styles = () => ({
  connectorSyncAlert: {
    display: 'flex',
    width: '100%',
    height: 66,
    padding: '12px 16px',
    borderBottom: '1px solid #e1e9f0',

    '&:last-of-type': {
      borderBottom: 0,
    },
  },

  syncAlertDetail: {
    marginLeft: 16,
    minWidth: 20,
    width: '100%',
  },

  syncMessage: {
    fontSize: 15,
    fontWeight: 500,
    color: '#27282a',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    maxWidth: '100%',
  },

  syncSubtext: {
    fontSize: 14,
    color: '#7b8b99',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    maxWidth: '100%',
  },

  syncState: {
    fontSize: 14,
    color: '#7b8b99',
    textAlign: 'right',
    whiteSpace: 'pre',
  },

  loadingContainer: {
    display: 'flex',
    alignItems: 'flex-end',
    flexDirection: 'column',
    justifyContent: 'center',
  },

  linearLoadingContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },

  booleanLoadingContainer: {
    display: 'flex',
  },

  logo: {
    width: 26,
    height: 26,
    flexShrink: 0,
  },

  loadingBar: {
    width: 250,
    margin: '7px 0',
    alignSelf: 'flex-end',
  },

  circularLoader: {
    width: 18,
    height: 18,
    marginRight: 8,
  },
});

export default styles;
